module.exports = __webpack_public_path__ + "static/img/awx.07d2c12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/awx.png
// module id = UZ8n
// module chunks = 1